import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-bold" }, " Activate Account Reminders ", -1)
const _hoisted_4 = { class: "text-grey-8 q-mt-xs" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "col-auto q-px-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_q_toggle = _resolveComponent("q-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.disabledAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(" Disabled "),
              _createVNode(_component_humanize_time, { time: _ctx.disabledAt }, null, 8, ["time"])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, " Send daily reminder email to activate their account. "))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_q_toggle, {
        "model-value": _ctx.enabled,
        color: "blue",
        disabled: _ctx.isLoading,
        "onUpdate:modelValue": _ctx.toggle
      }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
    ])
  ]))
}